import React from 'react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

import { TileImage as RecipeTileImage } from '../../RecipeTileImage/TileImage'
import { RecipeDietaryTagOverlay, RecipeTagLabels } from '../../../RecipeTileTags'
import { ImageContainer } from '../RecipeTile.styles'
import { SoldOutOverlay } from '../SoldOutOverlay'
import { getRecipeTileGeneralTags } from '../RecipeTile.utils'

type RecipeTileImageSectionProps = {
  recipe: StandardRecipeItem
  isOutOfStock: boolean
  lazy: boolean
  insideOverflow: boolean
}

export const RecipeTileImageSection = ({
  recipe,
  isOutOfStock,
  lazy,
  insideOverflow,
}: RecipeTileImageSectionProps) => {
  const generalTags = getRecipeTileGeneralTags(recipe)
  const dietaryTags = recipe.tagGroups.dietary ?? []

  return (
    <ImageContainer>
      <SoldOutOverlay isOutOfStock={isOutOfStock} />
      <RecipeTileImage
        lazy={lazy}
        recipe={{
          images: [
            {
              ...recipe.image,
              type: recipe.image.type ?? 'image',
            },
          ],
          name: recipe.title,
        }}
        insideOverflow={insideOverflow}
        testId="recipe-tile-image"
      />
      <RecipeTagLabels
        tags={generalTags}
        isOutOfStock={isOutOfStock}
        reserveEndSpace
        stacked
        dataTestId="recipe-tile-general-labels"
        style={{ left: 0 }}
      />
      <RecipeDietaryTagOverlay tags={dietaryTags} variant="stacked" />
    </ImageContainer>
  )
}
